module.exports = __webpack_public_path__ + "media/entities/3007-d2b31709.png";